import React from "react";
import { useRef } from "react";
import { Card, CardMedia, CardContent, CardActions, Typography, Button } from "@mui/material";
import { CardImg } from "reactstrap";
import { decompressToBase64, formatter } from "../../utils/common";
import "../Items/Item.css";
import Modal from "react-modal";
import ItemModal from "../Items/ItemModal.js";
import image from "../No_image_available.png";
import { AddToCart, GetCart, GetCount } from "../ShoppingCart/CartHandler.js";
import parse from "html-react-parser";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./NewCards.css"
import { Radio } from "@mui/joy";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const apiUrl = process.env.REACT_APP_BASEURL;

function NewCards(props) {
  const [activeItem, setActiveItem] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [startCard, setStartCard] = useState(0);
  const [endCard, setEndCard] = useState(5);
  const navigate = useNavigate();
  const [newCards, setNewCards] = useState([]);
  const [currNewCards, setCurrNewCards] = useState([]);
  const [selectedValue, setSelectedValue] = React.useState('location1');
  const [selectLocation, setSelectLocation] = useState("location 1")
  const [itemQty, setItemQty] = useState(1);

  const addItem = (newCard) => {
    AddToCart(newCard.itemDescription, newCard.images, newCard.itemNumber, newCard.price, itemQty);
    props.setCartCount(GetCount());
  };


  // let category = 'all';

  // if (!!sessionStorage.getItem("category")) {
  //         category = sessionStorage.getItem("category")
  //     }

  // const encodedValue = encodeURIComponent(category);

  const handleChange = (event) => {
    setSelectLocation(event.target.value);
  };

  useEffect(() => {
    findNewCards();
  }, [props.newCardsVal]);

  useEffect(() => {
    setCurrNewCards(newCards.slice(startCard, endCard));
  }, [newCards, startCard]);

  let onRequestClose = () => {
    setIsOpen(false);
    // setCartFunc(GetCart);
  };

  let handleClick = (item) => {
    setActiveItem(item);
    setIsOpen(true);
    props.setIsSwiper(false);
  };

  let handleMenuClick = (catName) => {
    let parentCategory = props.categories.find((category) =>
      category.children.some((child) => child.name === catName)
    );
    props.setCategory(parentCategory);
    navigate("/CategorySearchResults");
  };

  const buttonRightClick = () => {
    if (endCard + 5 > newCards.length) {
      setEndCard(newCards.length);
      setStartCard(newCards.length - 5);
    } else {
      setEndCard(endCard + 5);
      setStartCard(startCard + 5);
    }
  };

  const buttonLeftClick = () => {
    if (startCard - 5 < 0) {
      setStartCard(0);
      setEndCard(5);
    } else {
      setStartCard(startCard - 5);
      setEndCard(endCard - 5);
    }
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const findNewCards = async () => {

    if (props.newCardsVal === true) {

      await delay(2000); // Delay for 2 seconds
      axios.get(apiUrl + `/api/Items/GetAllNewest`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.token.token,
        },
      })
        .then((response) => {
          setNewCards(response.data); // Make sure response.data is an array
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const swiperRef = useRef(null);

  const renderNewCards = () => {
    if (newCards.length < 1) {
      return (
        <div role="status" class="space-y-2.5 animate-pulse md:h-[15em] w-screen">
        <div class="flex items-center w-full">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[80em]">
          <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
        </div>
        <div class="flex items-center w-full max-w-[70em]">
          <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[80em]">
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
        </div>
        <div class="flex items-center w-full max-w-[40em]">
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-32"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
        </div>
        <div class="flex items-center w-full max-w-[60em]">
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
          <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
          <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
        </div>
        <span class="sr-only">Loading...</span>
      </div>
      );
    } else {
      return (
        <div className={`max-w-6xl mx-auto py-8 inset-0 z-0 ${props.isSwiper ? "block" : "hidden"}`}>
          <h2 className="text-2xl font-bold text-center mb-6">New Products</h2>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 },  // Small screens: 1 card
              640: { slidesPerView: 3, spaceBetween: 25 },  // Medium screens: 2 cards
              1024: { slidesPerView: 4, spaceBetween: 50 }, // Large screens: 3 cards
            }}
            navigation={true}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="px-5 py-4 h-[auto]"
          >

            {!!newCards &&
              newCards.map((newCard) => (
                <SwiperSlide
                  onMouseEnter={() => swiperRef.current?.autoplay.stop()}
                  onMouseLeave={() => swiperRef.current?.autoplay.start()}
                  key={newCard.itemNumber} >
                  <Card
                    className="w-64 sm:w-56 md:w-60 lg:w-64 h-[400px] rounded-lg overflow-hidden p-3 shadow-md 
                      transition-all duration-300 ease-in-out hover:shadow-[0px_5px_15px_rgba(0,0,0,0.37)] hover:scale-[1.03] group cursor-pointer
                      flex flex-col justify-between"
                    onClick={() => handleClick(newCard)}
                  >
                    {/* Image Section */}
                    <div className="h-32 flex justify-center items-center bg-white">
                      <CardImg
                        top
                        className="card-picture"
                        src={
                          "data:image/png;base64," +
                          decompressToBase64(newCard.images[0]?.compressedImageData)
                        }
                        id={newCard.itemNumber + "Img"}
                        alt={newCard.itemNumber}
                      />
                    </div>

                    {/* Content Section (Moves Up on Hover) */}
                    <CardContent
                      className="flex-1 flex flex-col flex-grow justify-between p-2 transform transition-all duration-300 ease-in-out 
                        group-hover:-translate-y-2"
                         >
                      <Typography variant="h6" className="font-semibold text-gray-800 text-sm md:text-base">
                        {newCard.itemNumber}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className="text-blue-500 cursor-pointer hover:underline text-xs md:text-sm"
                      >
                        {newCard.categoryName}
                      </Typography>
                      <Typography variant="body2" className="text-gray-600 mt-1 text-xs md:text-sm line-clamp-2 h-10">
                        {newCard.itemDescription}
                      </Typography>
                      {newCard.available !== null && (
                        <Typography variant="body2" className="text-green-600 font-medium text-xs md:text-sm">
                          {newCard.available}
                        </Typography>
                      )}

                      {/* Location Dropdown */}
                      <div className="mt-2" onClick={(e) => {
                          e.stopPropagation();
                      }}>
                        <label className="text-gray-700 text-xs md:text-sm font-medium">Location</label>
                        <select
                          className="block w-full mt-1 p-1 border border-gray-300 rounded-md text-xs md:text-sm"
                          value={selectLocation}
                          onChange={handleChange}
                        >
                          <option value="stl">STL</option>
                          <option value="msl">MSL</option>
                        </select>
                      </div>
                    </CardContent>

                    {/* Price & Action Section (Moves Up on Hover) */}
                    <CardActions
                      className="p-2 flex justify-between items-center transform transition-all duration-300 ease-in-out 
                         group-hover:-translate-y-2"
                    >
                      <Typography variant="body1" className="font-bold text-gray-900 text-sm md:text-base min-w-[50px] text-right">
                        {formatter.format(newCard.price)}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        className="rounded-full text-xs md:text-sm w-34 h-9 flex justify-center items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          addItem(newCard);
                        }}
                      >
                        Add to Cart
                      </Button>
                    </CardActions>
                  </Card>

                </SwiperSlide>
              ))}

          </Swiper>
          {isOpen ? (
            <ItemModal
              setIsSwiper={props.setIsSwiper}
              selectLocation={selectLocation}
              item={activeItem}
              onRequestClose={onRequestClose}
              cartCount={props.cartCount}
              setCartCount={props.setCartCount}
            />
          ) : null}
        </div>
      );
    }
  };
  return <div className=" w-screen  md:px-10 sm:py-0 py-10 md:py-10 lg:py-10">{renderNewCards()}</div>;
}

// const customStyles = {
//     content: {
//         top: '50%',
//         left: '50%',
//         right: 'auto',
//         bottom: 'auto',
//         marginRight: '-50%',
//         transform: 'translate(-50%, -50%)',
//     },
// };

// Modal.setAppElement('#root');

// // Please see my two questions:
// // https://stackoverflow.com/questions/68518868/errors-getting-react-modal-in-my-react-component
// // https://stackoverflow.com/questions/68512119/how-to-make-multiple-items-fit-on-one-row-in-reactjs
// class NewCards extends React.Component {
//     constructor() {
//         super();
//         this.state = {
//             name: 'React',
//             apiData: [],
//             subCategories: [],
//             activeItem: null,
//             isOpen: false,
//             categoryDescription: "",
//             parent: "",
//         };
//     }

//     async componentDidMount() {
//         const tokenString = sessionStorage.getItem("token");
//         const token = JSON.parse(tokenString);

//         let headers = new Headers({
//             "Accept": "application/json",
//             "Content-Type": "application/json",
//             'Authorization': 'Bearer ' + token.token
//         });

//         let category = 'All'

//         if (!!sessionStorage.getItem("category")) {
//             category = sessionStorage.getItem("category")
//         }

//         const encodedValue = encodeURIComponent(category);

//         const response = await fetch(apiUrl + `/api/Items/GetAllNewest`, {
//             method: "GET",
//             headers: headers
//         });
//         const json = await response.json();
//         console.log(json);

//         if (Array.isArray(json)) {
//             this.setState({ itemList: json });
//         }
//         else {
//             this.setState({ itemList: null });
//         }

//         const response2 = await fetch(apiUrl + `/api/Items/GetSubCategories?category=${encodedValue}`, {
//             method: "GET",
//             headers: headers
//         });
//         const json2 = await response2.json();

//         this.setState({ subCategories: json2 });

//         const response3 = await fetch(apiUrl + `/api/Items/GetCategoryDescription?category=${encodedValue}`, {
//             method: "GET",
//             headers: headers
//         });
//         const json3 = await response3.json();

//         this.setState({ categoryDescription: json3 });

//         const response4 = await fetch(apiUrl + `/api/Items/GetCategoryParent?category=${encodedValue}`, {
//             method: "GET",
//             headers: headers
//         });
//         const json4 = await response4.json();

//         this.setState({ parent: json4 });
//     }

//     render() {
//         const items = this.state.itemList;
//         const { isOpen } = this.state;
//         const { activeItem } = this.state;

//         let onRequestClose = () => {
//             this.setState({ isOpen: false });
//             this.props.setCartFunc(GetCart);

//         }

//         let handleClick = (item) => {
//             this.setState({ activeItem: item });
//             this.setState({ isOpen: true });
//         }

//         let handleMenuClick = (category) => {
//             console.log(`you clicked ${category}`)
//             sessionStorage.removeItem("category");
//             sessionStorage.setItem("category", category);
//         }

//         return (
//             <div>
//                 <div>
//                     <CardColumns className="card-columns-5">
//                         {!!items && items.map(item =>
//                             <Card key={item.itemNumber}>
//                                 <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
//                                 <CardBody className="card-body">
//                                     <CardTitle tag="a" onClick={() => handleClick(item)} style={{ cursor: "pointer" }}>{item.itemNumber}</CardTitle><br />
//                                     <CardSubtitle tag="a" className="mb-2 text-muted" href="/categoryItems" onClick={() => handleMenuClick(item.categoryName)}>{item.categoryName}</CardSubtitle>
//                                     {item.available !== null ? <><CardText className="card-description-short">{item.itemDescription}</CardText><CardText>{item.available}</CardText></> : <CardText className="card-description">{item.itemDescription}</CardText>}
//                                 </CardBody>
//                                 <CardFooter className="text-muted">{formatter.format(item.price)}</CardFooter>
//                             </Card>
//                         )}
//                     </CardColumns>
//                     {isOpen ? <ItemModal item={activeItem} onRequestClose={onRequestClose} /> : null}
//                 </div>
//             </div>
//         );
//     }
// }
export default NewCards;
